import drReport from "./drReport.vue";
export default drReport;
